/* Kameo homepage concept C: interacties. Init per sectie, herbruikbaar in de
   theme editor via shopify:section:load. */
(function () {
  'use strict';
  if (window.__kameoC) return;
  window.__kameoC = true;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  function initReveals(scope) {
    var els = scope.querySelectorAll('.kc-reveal:not(.kc-zichtbaar)');
    if (!els.length) return;
    if (designMode || reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kc-zichtbaar'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kc-zichtbaar'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAftel(scope) {
    scope.querySelectorAll('[data-kc-aftel]').forEach(function (el) {
      if (el.dataset.kcInit) return;
      el.dataset.kcInit = '1';
      var eind = new Date(el.dataset.kcAftel);
      if (isNaN(eind)) { // fallback: aanstaande zondag 23:59
        eind = new Date();
        eind.setDate(eind.getDate() + ((7 - eind.getDay()) % 7 || 7));
        eind.setHours(23, 59, 59, 0);
      }
      var d = el.querySelector('[data-kc-dagen]'), u = el.querySelector('[data-kc-uren]'),
          m = el.querySelector('[data-kc-min]'), s = el.querySelector('[data-kc-sec]');
      var dagenChips = document.querySelectorAll('[data-kc-dagen-chip]');
      function tik() {
        var rest = Math.max(0, eind - new Date()) / 1000;
        if (d) d.textContent = Math.floor(rest / 86400);
        if (u) u.textContent = String(Math.floor(rest % 86400 / 3600)).padStart(2, '0');
        if (m) m.textContent = String(Math.floor(rest % 3600 / 60)).padStart(2, '0');
        if (s) s.textContent = String(Math.floor(rest % 60)).padStart(2, '0');
        dagenChips.forEach(function (c) { c.textContent = Math.ceil(rest / 86400); });
      }
      tik();
      setInterval(tik, 1000);
    });
  }

  function initKantel(scope) {
    if (reduceMotion || !window.matchMedia('(pointer:fine)').matches) return;
    scope.querySelectorAll('[data-kc-kantel]').forEach(function (beeld) {
      if (beeld.dataset.kcInit) return;
      beeld.dataset.kcInit = '1';
      var kaart = beeld.querySelector('.kc-kantel');
      if (!kaart) return;
      beeld.addEventListener('mousemove', function (e) {
        var r = beeld.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        kaart.style.transform = 'rotateY(' + (x * 7) + 'deg) rotateX(' + (y * -7) + 'deg)';
      });
      beeld.addEventListener('mouseleave', function () { kaart.style.transform = ''; });
    });
  }

  function initMarquee(scope) {
    scope.querySelectorAll('[data-kc-marquee]').forEach(function (baan) {
      if (baan.dataset.kcInit) return;
      baan.dataset.kcInit = '1';
      baan.innerHTML += baan.innerHTML;
    });
  }

  function telOp(el, doel, duur, formatter) {
    var t0 = performance.now();
    function stap(now) {
      var p = Math.min((now - t0) / duur, 1);
      el.textContent = formatter(1 - Math.pow(1 - p, 4), doel);
      if (p < 1) requestAnimationFrame(stap);
    }
    requestAnimationFrame(stap);
  }

  function initTellers(scope) {
    var doelen = [];
    scope.querySelectorAll('[data-kc-telop]').forEach(function (el) { doelen.push(el); });
    if (!doelen.length) return;
    function start(el) {
      if (el.dataset.kcInit) return;
      el.dataset.kcInit = '1';
      var soort = el.dataset.kcTelop;
      if (soort === 'aantal') {
        var doel = parseInt(el.dataset.kcDoel || '60000', 10);
        telOp(el, doel, 1600, function (ease, d) {
          return Math.round(d * ease).toLocaleString('nl-NL') + '+';
        });
      } else if (soort === 'smelt') {
        var eind = parseFloat(el.dataset.kcDoel || '0.18');
        telOp(el, eind, 1400, function (ease, d) {
          var n = 1.0 - (1.0 - d) * ease;
          return '€ ' + n.toFixed(2).replace('.', ',');
        });
      }
    }
    if (designMode || reduceMotion || !('IntersectionObserver' in window)) {
      doelen.forEach(function (el) {
        el.dataset.kcInit = '1';
        if (el.dataset.kcTelop === 'aantal') {
          el.textContent = parseInt(el.dataset.kcDoel || '60000', 10).toLocaleString('nl-NL') + '+';
        } else {
          el.textContent = '€ ' + parseFloat(el.dataset.kcDoel || '0.18').toFixed(2).replace('.', ',');
        }
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { start(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    doelen.forEach(function (el) { io.observe(el); });
  }


  function initSimpeleTellers(scope) {
    var els = [].slice.call(scope.querySelectorAll('[data-teller]'));
    if (!els.length) return;
    function zet(el, direct) {
      if (el.dataset.kcInit) return;
      el.dataset.kcInit = '1';
      var doel = parseInt(el.dataset.teller, 10) || 0, plus = el.dataset.plus ? '+' : '';
      if (direct) { el.textContent = doel.toLocaleString('nl-NL') + plus; return; }
      var t0 = performance.now();
      function stap(now) {
        var p = Math.min((now - t0) / 1500, 1);
        el.textContent = Math.round(doel * (1 - Math.pow(1 - p, 4))).toLocaleString('nl-NL') + plus;
        if (p < 1) requestAnimationFrame(stap);
      }
      requestAnimationFrame(stap);
    }
    if (designMode || reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { zet(el, true); });
      return;
    }
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { zet(e.target); io2.unobserve(e.target); } });
    }, { threshold: .4 });
    els.forEach(function (el) { io2.observe(el); });
  }


  /* Kaart-pins uit de echte winkeldata (Stockist), voor secties die alleen de kaart tonen. */
  function initKaartPins(scope) {
    var IJK = { left: .0850, right: .8926, top: .1283, bottom: .7988,
                latMax: 53.55, latMin: 50.75, lonMin: 3.36, lonMax: 7.23 };
    scope.querySelectorAll('[data-kc-kaartpins]').forEach(function (wrap) {
      if (wrap.dataset.kcInit) return;
      wrap.dataset.kcInit = '1';
      var tag = wrap.dataset.kcKaartpins, fallback = wrap.dataset.fallback;
      function plaats(rijen) {
        var teller = wrap.parentNode.querySelector('[data-kc-locaantal]');
        rijen.forEach(function (w, i) {
          var lat = parseFloat(w.latitude != null ? w.latitude : w.lat);
          var lon = parseFloat(w.longitude != null ? w.longitude : w.lon);
          if (isNaN(lat) || isNaN(lon)) return;
          var pin = document.createElement('span');
          pin.className = 'kc-pin';
          pin.style.left = (IJK.left + (lon - IJK.lonMin) / (IJK.lonMax - IJK.lonMin) * (IJK.right - IJK.left)) * 100 + '%';
          pin.style.top = (IJK.top + (IJK.latMax - lat) / (IJK.latMax - IJK.latMin) * (IJK.bottom - IJK.top)) * 100 + '%';
          pin.style.animationDelay = (i * .09) + 's';
          pin.title = (w.name || w.n || '').replace('Swiss Sense ', '');
          wrap.appendChild(pin);
        });
        if (teller) teller.textContent = rijen.length;
      }
      var bron = tag ? fetch('https://stockist.co/api/v1/' + tag + '/locations/all').then(function (r) { return r.json(); })
                     : Promise.reject();
      bron.then(function (d) { if (!d || !d.length) throw 0; plaats(d); })
          .catch(function () {
            if (fallback) fetch(fallback).then(function (r) { return r.json(); }).then(plaats).catch(function(){});
          });
    });
  }

  function initReviews(scope) {
    scope.querySelectorAll('[data-kc-reviews]').forEach(function (wrap) {
      if (wrap.dataset.kcInit) return;
      wrap.dataset.kcInit = '1';
      var slides = wrap.querySelectorAll('.kc-rb__slide');
      var dots = wrap.querySelectorAll('.kc-rb__dot');
      if (slides.length < 2) return;
      var index = 0, timer;
      function toon(i) {
        index = i;
        slides.forEach(function (s, n) { s.classList.toggle('kc-actief', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('kc-actief', n === i); });
      }
      function start() { timer = setInterval(function () { toon((index + 1) % slides.length); }, 5000); }
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { clearInterval(timer); toon(n); start(); });
      });
      start();
    });
  }

  function initAlles(scope) {
    initReveals(scope); initAftel(scope); initKantel(scope);
    initMarquee(scope); initTellers(scope); initSimpeleTellers(scope); initKaartPins(scope); initReviews(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAlles(document); });
  } else {
    initAlles(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAlles(e.target); });
})();
